import { Injectable, Injector } from '@angular/core';

/**
 * Injector service to inject dependencies
 *
 * @see https://devblogs.microsoft.com/premier-developer/angular-how-to-simplify-components-with-typescript-inheritance/
 */
@Injectable({
  providedIn: 'root'
})
export class AppInjectorService {

  private static injector: Injector;

  static setInjector(injector: Injector) {
    AppInjectorService.injector = injector;
  }

  static getInjector(): Injector {
    return AppInjectorService.injector;
  }
}
